import { type CreditCardItemConstructor } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { type ItemCostAllocationConstructor } from '@webapp/modules/accounts-payable/entities/ItemCostAllocation'
import {
  type CreditCardItemAllocationApiModel,
  type CreditCardItemApiModel,
} from '../api-models/CreditCardItemApiModel'

const mapAllocation = (
  allocation: CreditCardItemAllocationApiModel
): ItemCostAllocationConstructor => ({
  budgetId: allocation.budget.id,
  amount: allocation.amount,
  accountCode: {
    id: allocation.budget.account_code.id,
    code: allocation.budget.account_code.code,
    description: allocation.budget.account_code.description,
  },
  primaryCategory: {
    id: allocation.budget.department.branch.id,
    name: allocation.budget.department.branch.name,
  },
  secondaryCategory: {
    id: allocation.budget.department.id,
    name: allocation.budget.department.name,
  },
})

export const mapCreditCardItemApiModel = (
  model: CreditCardItemApiModel
): CreditCardItemConstructor => ({
  id: model.id,
  creditcardId: model.creditcard.id,
  description: model.description,
  totalCost: model.total_cost,
  currency: {
    id: model.currency.id,
    name: model.currency.name,
    rate: parseFloat(model.currency.rate),
    base: model.currency.base,
  },
  receivedOn: model.received_on,
  costAllocations: model.cost_allocations.map(mapAllocation),
  packingSlips: model.packing_slips.map((slip) => ({
    id: slip.id,
    uuid: slip.uuid,
    name: slip.name,
  })),
  po: model.po
    ? {
        number: model.po.number,
        uuid: model.po.uuid,
        vendorName: model.po.vendor_name,
      }
    : null,
  expense: model.expense
    ? {
        expenseReportId: model.expense.expenseReport.id,
        uuid: model.expense.expenseReport.uuid,
        merchant: model.expense.merchant,
      }
    : null,
  matchedStatementItemIds: model.matched_statement_items.map(
    (statementItem) => statementItem.id
  ),
  isMovable: model.creditcard_is_editable,
  unitCostDiffLog: model.unit_cost_diff_log
    ? {
        originalUnitCost: model.unit_cost_diff_log.original_unit_cost,
        originalCurrencyLabel: model.unit_cost_diff_log.original_currency_label,
      }
    : null,
})
